<template>
    <cic-popup
        id="edit_calendar"
        :title="value.calendarId ? 'Edit Holiday Calendar' : 'New Holiday Calendar'"
        :draggable="false"
        :saveable="true"
        class="no-padding"
        @blur="$emit('blur')"
        @input="$emit('input')"
    >
        <div>
            <ul>
                <li class="form-label-first">
                    {{ $t('Select Calendar') }}
                </li>
                <li>
                    <cic-select
                        id="calendar_select"
                        :value="value.calendarId"
                        :options="
                            [{ value: null, label: $t('[New Calendar]') }].concat(
                                calendars.map((x) => {
                                    return { value: x.calendarId, label: x.name };
                                }),
                            )
                        "
                        @input="selectCalendar"
                    />
                    <icon-button
                        v-if="value.calendarId"
                        id="calendar_delete"
                        :title="$t('Delete Calendar')"
                        icon="delete-icon"
                        @click="$emit('delete', value.calendarId)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('Calendar Name') }}
                </li>
                <li>
                    <cic-textbox
                        id="calendar_name"
                        :value="value.name"
                        :maxlength="63"
                        @input="(val) => updateFieldValue('name', val)"
                    />
                </li>
            </ul>
            <table id="ranges_table" class="cic-table">
                <thead>
                    <tr>
                        <th>{{ $t('Start Date') }}</th>
                        <th>{{ $t('End Date') }}</th>
                        <th>{{ $t('Description') }}</th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(range, rangeIndex) in item.ranges">
                        <td>
                            <cic-date-picker
                                :clearable="false"
                                :value="range.start"
                                @input="(val) => updateRange(rangeIndex, 'start', val)"
                            />
                        </td>
                        <td>
                            <cic-date-picker
                                :clearable="false"
                                :value="range.end"
                                @input="(val) => updateRange(rangeIndex, 'end', val)"
                            />
                        </td>
                        <td>
                            <cic-textbox
                                :value="range.description"
                                @input="(val) => updateRange(rangeIndex, 'description', val)"
                            />
                        </td>
                        <td>
                            <icon-button
                                v-if="value.ranges.length > 1"
                                icon="remove-icon"
                                @click="removeRange(rangeIndex)"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colspan="3"></td>
                        <td><icon-button icon="add-icon" @click="addRange" /></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </cic-popup>
</template>

<script>
    import moment from 'moment';
    import CicDatePicker from '@/components/CicDatePicker';
    import CicPopup from '@/components/CicPopup';
    import IconButton from '@/components/controls/IconButton';
    import CicSelect from '@/components/inputs/CicSelect';
    import CicTextbox from '@/components/inputs/CicTextbox';

    export default {
        name: 'EditCalendar',
        components: {
            IconButton,
            CicDatePicker,
            CicPopup,
            CicSelect,
            CicTextbox,
        },
        props: {
            value: {
                type: Object,
                required: true,
            },
            calendars: {
                type: Array,
                required: true,
            },
        },
        emits: ['blur', 'change', 'delete', 'input'],
        computed: {
            item() {
                let item = JSON.parse(JSON.stringify(this.value));
                item.ranges = item.ranges.map((x) => {
                    x.start = moment(x.start);
                    x.end = moment(x.end);
                    return x;
                });
                return item;
            },
        },
        methods: {
            addRange() {
                let item = JSON.parse(JSON.stringify(this.value));
                item.ranges.push({
                    start: moment().format('YYYY-MM-DD'),
                    end: moment().format('YYYY-MM-DD'),
                    description: '',
                });
                this.$emit('change', item);
            },

            removeRange(index) {
                let item = JSON.parse(JSON.stringify(this.value));
                item.ranges.splice(index, 1);
                this.$emit('change', item);
            },

            selectCalendar(val) {
                if (val === null) {
                    this.$emit('change', {
                        calendarId: null,
                        name: '',
                        ranges: [
                            {
                                start: moment().format('YYYY-MM-DD'),
                                end: moment().format('YYYY-MM-DD'),
                                description: '',
                            },
                        ],
                    });
                } else {
                    let item = this.calendars.find((x) => x.calendarId === val);
                    this.$emit('change', item);
                }
            },

            updateFieldValue(field, val) {
                let item = JSON.parse(JSON.stringify(this.value));
                item[field] = val;
                this.$emit('change', item);
            },

            updateRange(index, field, val) {
                let item = JSON.parse(JSON.stringify(this.value));
                item.ranges[index][field] = field === 'description' ? val : val.local().format('YYYY-MM-DD');
                this.$emit('change', item);
            },
        },
    };
</script>
